/**
 * Como a tela fala de QUEM REGISTROU pelo banco — operador ou master, e a sub
 * organizacao do momento. Um lugar so' para o detalhe da proposta, o relatorio
 * de Consignacoes, o historico do contrato e a Auditoria nao divergirem no
 * rotulo.
 */
import type { BancoAgente } from "@atlas/sdk";

export const ORGANIZACAO_PRINCIPAL = "Organização principal";
export const NAO_REGISTRADO = "Não registrado";

/** `null`/ausente = contrato anterior ao registro (01/10/2026). */
export function rotuloSubOrganizacao(a: Pick<BancoAgente, "subOrganizacaoId" | "subOrganizacaoNome"> | null | undefined): string {
  if (!a) return NAO_REGISTRADO;
  if (!a.subOrganizacaoId) return ORGANIZACAO_PRINCIPAL;
  return a.subOrganizacaoNome ?? a.subOrganizacaoId;
}

/** "Maria Souza · Filial Fortaleza" / "BANCO X · Organização principal". */
export function rotuloRegistro(a: BancoAgente | null | undefined): string {
  if (!a) return NAO_REGISTRADO;
  return `${a.usuarioNome} · ${rotuloSubOrganizacao(a)}`;
}
